(function () {
  // --- Utilities ---
  const debounce = (fn, wait = 500) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), wait);
    };
  };

  // Collect selected filters from your checkbox markup
  function collectFilters() {
    const byTax = {};
    document
      .querySelectorAll('.post-taxonomies-list input[type="checkbox"]:checked')
      .forEach((el) => {
        const tax = el.getAttribute("data-taxonomy");
        const term = el.value;
        if (!byTax[tax]) byTax[tax] = [];
        byTax[tax].push(term);
      });

    return {
      locations: byTax["job_listing_category"] || [],
      role_types: byTax["job_listing_type"] || [],
    };
  }

  // Read search inputs (from your custom top form)
  function collectSearch() {
    const kw = document.getElementById("search_keywords");
    const loc = document.getElementById("search_location");
    return {
      keywords: kw ? kw.value.trim() : "",
      location: loc ? loc.value.trim() : "",
    };
  }

  // Replace results HTML
  function renderResults(html) {
    // The AJAX returns a full <ul> + pagination. Replace the whole results region if possible.
    const container =
      document.querySelector(".rm-filter-results.job_listings")
        ?.parentElement ||
      document.querySelector(".job_listings_container") ||
      document;
    // Create a temp wrapper to parse HTML
    const wrap = document.createElement("div");
    wrap.innerHTML = html;

    // Prefer replacing the UL
    const newList = wrap.querySelector(".rm-filter-results.job_listings");
    const oldList = document.querySelector(".rm-filter-results.job_listings");

    if (newList && oldList) {
      // Replace UL
      oldList.replaceWith(newList);
      // Also update/replace the pager and "Show All" controls
      const newPager = wrap.querySelector(".pager");
      const oldPager = container.querySelector(".pager");
      if (oldPager && newPager) oldPager.replaceWith(newPager);
      else if (oldPager && !newPager) oldPager.remove();
      else if (!oldPager && newPager)
        newList.insertAdjacentElement("afterend", newPager);

      const newShowAll = wrap.querySelector(".show-all");
      const oldShowAll = container.querySelector(".show-all");
      if (oldShowAll && newShowAll) oldShowAll.replaceWith(newShowAll);
      else if (oldShowAll && !newShowAll) oldShowAll.remove();
      else if (!oldShowAll && newShowAll)
        (newPager || newList).insertAdjacentElement("afterend", newShowAll);
    } else {
      // Fallback: just dump all
      if (oldList) {
        oldList.innerHTML = html;
      }
    }
  }

  // --- Core AJAX ---
  const runQuery = debounce(function (page = 1, opts = { showAll: false }) {
    const { locations, role_types } = collectFilters();
    const { keywords, location } = collectSearch();

    const params = {
      postType: "job_listing",
      tax: {
        job_listing_category: locations,
        job_listing_type: role_types,
      },
      quantity: 20,
      page: page,
    };

    const form = new FormData();
    form.append("action", "filter_job_listings");
    form.append("security", CB_JOB_FILTER.security);
    form.append("locations", JSON.stringify(locations));
    form.append("role_types", JSON.stringify(role_types));
    form.append("keywords", keywords);
    form.append("job_location", location);
    form.append("page", String(page));
    form.append("show_all", opts.showAll ? "1" : "0");

    document.querySelector("#filter-by").scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });

    fetch(CB_JOB_FILTER.ajaxurl, {
      method: "POST",
      body: form,
      credentials: "same-origin",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data && data.success) {
          renderResults(data.data);
        }
      })
      .catch((e) => console.error("Job filter error", e));
  }, 500);

  // Expose for other scripts if needed
  window.CBRunJobQuery = runQuery;

  // --- Events ---

  // Checkboxes
  document.addEventListener("change", (e) => {
    if (e.target.matches('.post-taxonomies-list input[type="checkbox"]')) {
      runQuery(1, { showAll: false });
    }
  });

  // Search form: submit button
  const searchForm = document.querySelector(".search-jobs");
  if (searchForm) {
    const submit = searchForm.querySelector(
      '.search_submit input[type="submit"]',
    );
    if (submit) {
      submit.addEventListener("click", (e) => {
        e.preventDefault();
        runQuery(1, { showAll: false });
      });
    }

    // Typing debounce
    const kw = searchForm.querySelector("#search_keywords");
    const loc = searchForm.querySelector("#search_location");
    // add back if want to run search when typing
    // if (kw) kw.addEventListener("input", () => runQuery(1, { showAll: false }));
    // if (loc)
    //   loc.addEventListener("input", () => runQuery(1, { showAll: false }));

    // Enter key submits
    searchForm.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        runQuery(1, { showAll: false });
      }
    });
  }

  // Clear filters button (if present)
  const clearBtn = document.querySelector(".clear-filter-btn");
  if (clearBtn) {
    clearBtn.addEventListener("click", (e) => {
      e.preventDefault();
      document
        .querySelectorAll('.post-taxonomies-list input[type="checkbox"]')
        .forEach((el) => (el.checked = false));
      const kw = document.getElementById("search_keywords");
      const loc = document.getElementById("search_location");
      if (kw) kw.value = "";
      if (loc) loc.value = "";
      runQuery(1, { showAll: false });
    });
  }

  // Pagination: Prev/Next
  document.addEventListener("click", function (e) {
    const a = e.target.closest(".prev, .next");
    if (!a || a.classList.contains("is-disabled")) return;
    const page = parseInt(a.getAttribute("data-page") || "1", 10);
    if (Number.isNaN(page)) return;
    e.preventDefault();
    runQuery(page, { showAll: false });
  });

  // Pagination: Typable input
  document.addEventListener("keydown", function (e) {
    const input = e.target.closest(".page-input");
    if (!input) return;
    if (e.key !== "Enter") return;

    e.preventDefault();
    const total = parseInt(
      document.querySelector(".total")?.textContent || "1",
      10,
    );
    let page = parseInt(input.value || "1", 10);
    if (Number.isNaN(page) || page < 1) page = 1;
    if (page > total) page = total;

    runQuery(page, { showAll: false });
  });

  // Show All
  document.addEventListener("click", function (e) {
    const link = e.target.closest(".show-all-link");
    if (!link) return;
    e.preventDefault();
    runQuery(1, { showAll: true });
  });

  // No-results inline clear link
  document.addEventListener("click", function (e) {
    const link = e.target.closest(".js-clear-all");
    if (!link) return;
    e.preventDefault();
    document
      .querySelectorAll('.post-taxonomies-list input[type="checkbox"]')
      .forEach((el) => (el.checked = false));
    const kw = document.getElementById("search_keywords");
    const loc = document.getElementById("search_location");
    if (kw) kw.value = "";
    if (loc) loc.value = "";
    runQuery(1, { showAll: false });
  });

  document.addEventListener("DOMContentLoaded", accordion);
  function accordion() {
    const accordionButtons = document.querySelectorAll(".accordion-header");
    accordionButtons.forEach((button) => {
      // Check if the button is already active on initial load
      const content = button.nextElementSibling;
      if (button.classList.contains("active")) {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      button.addEventListener("click", function () {
        if (this.classList.contains("active")) {
          this.classList.remove("active");
          this.parentElement.classList.remove("active");
          this.setAttribute("aria-expanded", "false");
          content.style.maxHeight = null;
        } else {
          this.classList.add("active");
          this.parentElement.classList.add("active");
          this.setAttribute("aria-expanded", "true");
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    });
  }
})();
